import { render, staticRenderFns } from "./linkPicSvg.vue?vue&type=template&id=29556f48&scoped=true"
var script = {}
import style0 from "./linkPicSvg.vue?vue&type=style&index=0&id=29556f48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29556f48",
  null
  
)

export default component.exports